import React, { useContext } from "react";

import { useApolloClient } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ReactComponent as ChevronDown } from "shared/assets/ChevronDown.svg";
import { ReactComponent as User } from "shared/assets/User.svg";
import Dropdown from "shared/components/Dropdown";
import Logo from "shared/components/Logo";
import { NAME_SPACES } from "shared/locals/constants";
import { StoreContext } from "shared/store";
import { PATHS } from "utils/constants";

import "./styles.scss";

const Header = () => {
  const client = useApolloClient();
  const { t } = useTranslation(NAME_SPACES.HOME);
  const history = useHistory();
  const {
    clearStore,
    customerInfo: { fullname },
  } = useContext(StoreContext);

  const onLogout = async () => {
    await client.cache.reset();
    clearStore();
  };

  const navigateToProfile = () => {
    history.push(PATHS.ACCOUNT);
  };

  const items = [
    {
      key: "account",
      label: t("ACCOUNT"),
      onClick: navigateToProfile,
    },
    {
      key: "logout",
      label: t("LOGOUT"),
      onClick: onLogout,
    },
  ];

  return (
    <div className={"header"}>
      <Logo withDesc={true} width={128} />
      <Dropdown
        items={items}
        label={fullname}
        icon={
          fullname ? (
            <ChevronDown className={"right"} />
          ) : (
            <User className={"right"} />
          )
        }
      />
    </div>
  );
};

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
